import React, { memo } from 'react';

import SvgSprite from '@/components/atomic/atoms/data-display/icons/icon-sprite';
import FlexItem from '@/components/atomic/atoms/layout/flex-item';
import TopNavItemRenderer from '@/components/atomic/molecules/navigation/top-nav-items/item/renderer';
import TopNavItemBuilds from '@/components/atomic/molecules/navigation/top-nav-items/item/special-items/builds';
import TopNavItemLanguageSelector from '@/components/atomic/molecules/navigation/top-nav-items/item/special-items/language-selector';
import type { TopNavigationItemPreloadedProps } from '@/components/atomic/molecules/navigation/top-nav-items/item/typings';
import ViewportRender from '@/components/atomic/molecules/utils/viewport/viewport-render';
import withExposer from '@/hocs/with-exposer';
import useIsIconValid from '@/hooks/use-is-icon-valid';
import normalisePath from '@/utils/path-helper';
import { useTheme } from '@emotion/react';

const TopNavItemSpecialItemsHandlerComponent: React.FC<
	TopNavigationItemPreloadedProps
> = (props) => {
	const {
		id,
		ariaLabel,
		label,
		link,
		fragmentVariationPath,
		dropdownSegment,
		icon,
		model,
		$variant,
	} = props;

	const { size } = useTheme();
	const isIconValid = useIsIconValid(icon);

	if (id === 'language-selector')
		return (
			<TopNavItemLanguageSelector
				id={id}
				ariaLabel={ariaLabel}
				fragmentVariationPath={fragmentVariationPath}
				icon={icon}
				label={label}
				link={normalisePath(link)}
				dropdownSegment={dropdownSegment}
				model={model}
				$variant={$variant}
			/>
		);

	if (id === 'builds')
		return (
			<TopNavItemBuilds
				id={id}
				ariaLabel={ariaLabel}
				label={label}
				link={normalisePath(link)}
				fragmentVariationPath={fragmentVariationPath}
				dropdownSegment={dropdownSegment}
				icon={icon}
				$variant={$variant}
			/>
		);

	return (
		<TopNavItemRenderer
			id={id}
			ariaLabel={ariaLabel}
			label={label}
			link={normalisePath(link)}
			fragmentVariationPath={fragmentVariationPath}
			dropdownSegment={dropdownSegment}
			left={
				isIconValid ? (
					<FlexItem
						$alignItems='center'
						$justifyContent='center'
						$width={24}
						$breakpoints={{ [size.laptop]: { $width: 'auto' } }}
					>
						<ViewportRender
							Component={SvgSprite}
							componentProps={{
								icon,
								$width: 18,
								$height: 18,
							}}
							$breakpoints={{
								[size.laptop]: {
									Component: SvgSprite,
									componentProps: {
										icon,
										$width: 20,
										$height: 20,
									},
								},
							}}
						/>
					</FlexItem>
				) : null
			}
			right={
				label ? (
					<FlexItem $alignItems='center'>
						<span>{label}</span>
					</FlexItem>
				) : null
			}
			$variant={$variant}
		/>
	);
};

const TopNavItemSpecialItemsHandler = memo(
	withExposer(
		TopNavItemSpecialItemsHandlerComponent,
		'topNavItemSpecialItemsHandler',
	),
);

export default TopNavItemSpecialItemsHandler;
